import { Injectable } from '@angular/core';
import introJs from 'intro.js';

export type IntroStep = {
  element: string;
  intro: string;
  position?: 'left' | 'right' | 'top' | 'bottom' | 'bottom-right-aligned';
}

@Injectable({
  providedIn: 'root'
})
export class TourService {

  startTour(steps: IntroStep[]) {
    const validSteps = this.filterExistingElements(steps);

    introJs.tour().setOptions({
      steps: validSteps,
      nextLabel: 'Next →',
      prevLabel: '← Back',
      doneLabel: 'Done',
      exitOnOverlayClick: false,
      showStepNumbers: true,
      disableInteraction: false,
      scrollToElement: true,
      showBullets: true,
    }).start();
  }

  private filterExistingElements(steps: IntroStep[]): IntroStep[] {
    return steps.filter(step => {
      if (!step.element) return true;
      try {
        return document.querySelector(step.element) !== null;
      } catch (error) {
        console.warn(`Invalid selector in intro step: ${step.element}`, error);
        return false;
      }
    });
  }
}
